const ProjectData = [
  {
    title: "EcoSwap",
    text:
      "Eco-Swap is an E-commerce Website that promotes donating and paying it forward to the community for a sustainable future. The website was built using HTML, JavaScript, and CSS",
    url: "https://github.com/maahasghar/RBC_Hacks_NGI-",
  },

  {
    title: "Retro Maze Game",
    text:
      "Retro Maze is a two-player game where Donkey must find the exit before Shrek catches him to reach the next level. This game was built as a part of a course project using C/C++ and raspberry pi.",
    url: "https://github.com/maahasghar/Retro_Maze",
  },
  
  {
    title: "Porfolio Website",
    text:
      "This portfolio website is created to introduce myself, and also showcase my skills and some of my past projects. It was created using ReactJs, npm, CSS,  and JavaScript.",
    url: "https://github.com/maahasghar/portfolio_site",
  },
];

export default ProjectData;
